import { requestDelete, requestGet, requestPatch } from '@/api/api'

const list = {
    data () {
        return {
            loading: false, // 列表loading
            isShow: '',
            list: [], // 列表
            orderID: 'order',
            orderVal: 'asc',
            search: false, // 高级搜索是否展示
            size: 'default', // 表格默认密度
            bordered: true,
            params: {
                where: {},
                sort: {}
            },
            pagination: {
                // 列表分页
                pageSizeOptions: ['1', '20', '50', '100'],
                showSizeChanger: true, // 是否显示选择下拉分页
                showQuickJumper: true, // 是否显示跳转页码
                onShowSizeChange: (current, pageSize) => {
                    // 下拉分页选择
                    this.params.perpage = pageSize
                    this.params.page = 1
                    this.getLists()
                },
                onChange: current => {
                    // 点击分页
                    this.pagination.current = current
                    this.params.page = current
                    this.getLists()
                }
            }
        }
    },
    watch: {
        'params.where': {
            handler (newValue, oldValue) {
                this.params.page = 1
                this.pagination.current = 1
            },
            deep: true
        },
        'params.sort': {

            handler (newValue, oldValue) {
                this.params.page = 1
                this.pagination.current = 1
            },
            deep: true
        }
    },
    methods: {
        /**
         * 获取列表
         *
         * @params
         */
        getLists (extra) {
            this.loading = true
            const { params } = this
            const { apiList } = this
            requestGet(apiList.getList, params)
                .then(res => {
                    const pagination = { ...this.pagination }
                    const { result } = res
                    console.log('getList:')
                    console.log(res)
                    this.result = result
                    pagination.total = result.paginate.total
                    pagination.pageSize = result.paginate.perpage
                    pagination.showTotal = function () {
                        return '共:' + result.paginate.total + '条数据'
                    }
                    if (extra) {
                       this[extra] = result[extra]
                    }
                    this.list = result.data
                    console.log('this.list')
                    console.log(this.list)
                    this.pagination = pagination
                })
                .finally(() => {
                    this.loading = false
                })
        },
        /**
         * 修改状态
         * {
         *  id
         *  state
         * }
         * @param
         */
        handleChangeState (id) {
            this.loading = !this.loading // 加载
            const { apiList } = this
            requestPatch(apiList.changeState + id)
                .then(res => {
                    this.$notification.success({
                        message: res.msg
                    })
                    this.getLists()
                })
                .finally(() => {
                    this.loading = !this.loading // 加载关闭
                })
        },
        /**
         * 删除
         * @JDY
         * @2020/12/11
         */
        handleOnDelete (id) {
            this.loading = true
            const { apiList } = this
            requestDelete(apiList.delete + id)
                .then(res => {
                    this.$notification.success({
                        message: res.msg
                    })
                    this.getLists()
                })
                .finally(() => {
                    this.loading = false
                })
        },
        /**
         * 批量删除
         * @param id ?? selectedRowKeys
         * @jdy
         */
         handleBatchesDelete (id) {
            this.loading = true
            const ids = id ?? this.selectedRowKeys.join(',')
            const parameter = {
                id: ids
            }
            const { apiList } = this
            requestDelete(apiList.delete, parameter)
                .then(res => {
                    if (res.code === '200') {
                        this.$notification.success({
                            message: res.msg
                        })
                        this.getLists()
                    } else {
                        this.$notification.error({
                            message: res.msg
                        })
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        }

    },
    created () {}
}
export default list
